export default "__VITE_ASSET__ad4530fb__"